import { gql } from '@apollo/client';

export const GIVE_UP = gql`
    mutation giveUp($url: String!) {
        giveUp(url: $url) {
            status
        }
    }
`;
